// Utils
import hasRole from './hasRole'

// Constants
import {
  ROLE_GROWER,
} from '../constants'

// Exports
export default hasRole(ROLE_GROWER, {
  ifUndefined: true,
})
